import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.lotuspreschool.co.za/api/v1',
});

console.log('API Base URL:', process.env.REACT_APP_API_URL);

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lotus_admin_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  console.log('Request:', { url: config.url, method: config.method, baseURL: config.baseURL });
  return config;
});

api.interceptors.response.use(
  (response) => {
    console.log('Response:', { status: response.status, url: response.config.url });
    return response;
  },
  (error) => {
    console.error('Response Error:', { status: error.response?.status, message: error.message, url: error.config?.url });
    return Promise.reject(error);
  }
);

export default api;
